// src/views/scannedData/useScans.js
import { useEffect, useState } from "react";
import { database } from "../../firebase";
import { ref, onValue } from "firebase/database";

export default function useScans(user, viewUserID) {
  const [scans, setScans] = useState([]);

  useEffect(() => {
    if (!user?.email && !viewUserID) return;

    // Use viewUserID if provided (admin viewing another user), otherwise use user's email
    const userPath = viewUserID || user.email.replaceAll(".", "-");
    const scanRef = ref(database, `data/scans/${userPath}`);
    const cacheKey = `scans_${userPath}`;

    const cached = localStorage.getItem(cacheKey);
    if (cached) {
      try {
        setScans(JSON.parse(cached));
      } catch {
        localStorage.removeItem(cacheKey);
      }
    }

    const unsubscribe = onValue(scanRef, (snapshot) => {
      if (!snapshot.exists()) {
        setScans([]);
        localStorage.removeItem(cacheKey);
        return;
      }

      const entries = Object.entries(snapshot.val()).map(([key, value]) => ({
        ...value,
        key,
      }));

      const sorted = entries.toSorted((a, b) => {
        const ta = Number(a.createTimestamp ?? a.timestamp ?? 0);
        const tb = Number(b.createTimestamp ?? b.timestamp ?? 0);
        return tb - ta;
      });

      setScans(sorted);

      try {
        localStorage.setItem(cacheKey, JSON.stringify(sorted));
      } catch { }
    });

    return () => unsubscribe();
  }, [user, viewUserID]);

  return scans;
}
